import { mapState } from 'vuex';
import store from '@/store/store';
import apiClient from '@/apiClient';

import ConfirmModal from '@/components/ui/modals/ConfirmModal/ConfirmModal.vue';

export default {
  name: 'PlanSelect',

  props: {
    plans: {
      type: Array,
      required: true
    },

    balance: {
      type: Number,
      required: true
    },

    userPlan: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      selectedPlan: ''
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id
    }),

    selectablePlans() {
      let selectablePlans = [];
      this.plans.forEach(plansGroup => {
        selectablePlans = selectablePlans.concat(plansGroup.tariffs);
      });
      return selectablePlans;
    },

    selectedPlanPriceFull() {
      return this.selectedPlan.price !== undefined
        ? this.selectedPlan.price
        : 0;
    },

    selectedPlanPriceMonth() {
      if (this.selectedPlan.price === undefined) return '-';
      return Math.ceil(
        parseFloat(this.selectedPlan.price) / (this.selectedPlan.duration / 30)
      );
    },

    selectedPlanSavings() {
      return this.selectedPlan.savings;
    },

    selectedPlanDelta() {
      return Math.ceil(this.selectedPlan.price - this.balance);
    },

    isCurrentUserPlan() {
      return this.userPlan.id === this.selectedPlan.id;
    }
  },

  methods: {
    getPlanGroupName(groupId) {
      return this.plans.filter(group => {
        return group.id === groupId;
      })[0].title;
    },

    changePlan() {
      this.$refs.confirmModal.open();
    },

    changePlanConfirm() {
      store.commit('startLoad');
      new Promise((resolve, reject) => {
        apiClient
          .put(`/firms/${this.firmId}/billings/tariff`, {
            id: this.selectedPlan.id
          })
          .then(response => {
            if (response.data[0]) {
              window.open(response.data[0].url, '_self');
            } else {
              Promise.all([
                this.$store.dispatch('paymentsHistoryGet', this.firmId),
                this.$store.dispatch('getUserBalance', this.firmId)
              ]).then(() => {
                this.flashSuccess('Тариф изменен');
                this.$store.commit('endLoad');
              });
            }
            resolve(response);
          })
          .catch(err => {
            this.$store.commit('endLoad');
            this.flashError('Не удалось сменить тариф');
            reject(err);
          });
      });
    },

    changePlanAndPay() {
      this.$refs.planPaymentModal.open();
    }
  },

  components: {
    ConfirmModal
  }
};
